import api from './api'; 

const companyService = {
  onboard: async (onboardingData) => {
    try {
      const response = await api.post('/companies/onboard', onboardingData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Connection to server failed' };
    }
  }
};

export default companyService;